import api, { postExecutePGM } from 'services/api/microfwk';
import {
  CLEAR_PLAYER_DATA,
  FETCH_PLAYER_GET_MEDIA_INIT,
  FETCH_PLAYER_GET_MEDIA_SUCCESS,
  SET_COUNTER_HBO_ERROR,
  SET_UNIX_BEGIN,
} from 'containers/Player/actions/player/constants';
import { showPlayerError } from 'containers/Player/actions/errors/errors.actions';
import { showEpgTransactions } from 'containers/Player/actions/epgTransactions/epgTransactions.actions';
import { getRegion } from 'utils/Region';
import { getPurchaseButtonInfoForEPGTransactions } from 'action-creators/payway/purchaseButtonInfo';
import qs from 'qs';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { selectIsLiveChannel } from 'containers/Player/selectors/media.selector';
import { PLAYER_GETMEDIA_PATH } from 'api/services/player/paths';
import { getPlayerMediaService } from 'api/services/player';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { browserHistory } from 'react-router';
import { getPlayerGetMediaPath } from './utiils/getPlayerGetMediaPath';

export const getMediaRecording = (url, device_id) => {
  const params = qs.parse(url?.split('?')?.[1]);
  params.device_id = device_id;
  return async dispatch => {
    try {
      dispatch({ type: FETCH_PLAYER_GET_MEDIA_INIT });
      setTimeout(async () => {
        const request = qs.stringify({ ...params });
        const response = await axios.post(`${url?.split('?')?.[0]}?${request}`);
        if (response?.data?.status >= 300) {
          throw response.data.errors.length > 0
            ? response?.data?.errors?.[0]
            : '';
        }
        dispatch({
          type: FETCH_PLAYER_GET_MEDIA_SUCCESS,
          data: response.data.response,
        });
      }, 0);
    } catch (e) {
      return dispatch(showPlayerError(e));
    }
  };
};

export const getMedia = (
  params,
  payway_token,
  user_token,
  navigate,
  isLive,
  dashwvEnabled = false,
) => async (dispatch, getState) => {
  try {
    let store = getState();
    const contentData = getState()?.Player.Content
    const claroLiteConfig = getClaroAdsKey(store);
    const claroLiteEnable = claroLiteConfig || false;
    const playerGetMediaObject = getPlayerGetMediaPath(
      claroLiteConfig,
      isLive,
      user_token,
      payway_token,
      contentData,
    );

    const apiParams = {
      ...params,
      api_version: playerGetMediaObject?.apiVersion,
      user_token: playerGetMediaObject.userToken,
      payway_token: playerGetMediaObject.paywayToken,
    };
    dispatch({ type: FETCH_PLAYER_GET_MEDIA_INIT });

    const mediaServiceParams = {
      url: playerGetMediaObject?.url,
      formData: playerGetMediaObject.bodyParams,
      params: apiParams,
      claroLiteConfig: claroLiteEnable,
    };
    const response = await getPlayerMediaService(mediaServiceParams).then(
      response => response,
    );
    const errorFromPgm = response?.response?.data || response?.data || response;
    if (errorFromPgm.status >= 300) {
      throw errorFromPgm.errors?.length > 0 ? errorFromPgm?.errors?.[0] : '';
    }
    dispatch({
      type: FETCH_PLAYER_GET_MEDIA_SUCCESS,
      data: response?.data?.response ||  response?.data?.data,
      request: { params, user_token, payway_token },
    });
  } catch (e) {
    console.log(e, 'PLAY');
    const counterAttemptsToRetryHbo = getState()?.Player?.Player?.counterErrorHbo
    const error = e?.response?.data?.errors?.[0] || e;
    dispatch(hidePlayerLoader());
    switch (error?.code) {
      case 'PLY_HBO_00001':
        dispatch(showPlayerLoader())
        const counter = counterAttemptsToRetryHbo + 1
        const maxRetryHboJson = JSON.parse(getState()?.metadata?.retries_HBO) || {}
        const maxRetryHbo = maxRetryHboJson?.[getRegion()] || maxRetryHboJson?.default || 0
        if(counterAttemptsToRetryHbo< maxRetryHbo) return dispatch(setCounterErrorHbo(counter))
            await dispatch(showPlayerError(error))
            await dispatch(setCounterErrorHbo(0))
            await dispatch(hidePlayerLoader());
            return
      case 'PLY_CSS_00001':
        return dispatch(showPlayerError(error));
      case 'PLY_PLY_00007':
        let store = getState();
        const epgLineup = store?.EpgLineUp?.data;
        let linealChannels = store?.linealChannel?.data;
        const groupId = params?.group_id;
        let isLive = epgLineup?.find(channel => channel?.group_id === groupId);
        const channelCanPlayFromEpgLineup = epgLineup?.find(
          channel => linealChannels?.[channel?.group_id]?.live.canPlay === 1,
        );
        if (isLive) {
          //TRANSACCION INDUCIDA
          const goTransaction = browserHistory?.getCurrentLocation()?.query
            ?.toBuy;
          if (goTransaction) {
            dispatch(
              getPurchaseButtonInfoForEPGTransactions({
                group_id: params?.group_id,
              }),
            );
            dispatch(
              showEpgTransactions(store?.Player?.Content?.data?.group?.common),
            );
          }
          dispatch(showPlayerLoader());
          return navigate(
            `/${getRegion()}/watch/${channelCanPlayFromEpgLineup?.group_id}?r`,
          );
        } else {
          return dispatch(showPlayerError(error));
        }
      default:
        return dispatch(showPlayerError(error));
    }
  }
};

export const getServerIp = url =>
  api
    .get(url)
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const showPlayerLoader = () => ({
  type: 'SHOW_PLAYER_LOADER',
  showLoader: true,
});

export const hidePlayerLoader = () => ({
  type: 'HIDE_PLAYER_LOADER',
  showLoader: false,
});

export const clearPlayerData = () => ({
  type: CLEAR_PLAYER_DATA,
});

export const setUnixBegin = unixBegin => ({
  type: SET_UNIX_BEGIN,
  payload: unixBegin,
});

export const setCounterErrorHbo = counter =>({
  type: SET_COUNTER_HBO_ERROR,
  payload: counter,

})
